import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

export default class SearchArea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedValues: props.values,
      active: props.values ? props.values.length > 0 : false
    }

    this.handleSelectChangeBound = this.handleSelectChange.bind(this)
    this.onClickBound = this.onClick.bind(this)
    this.onBlurBound = this.onBlur.bind(this)
    this[props.area] = React.createRef()
  }

  componentDidMount () {
    // Hacky-css way to not display the clickable 'x' next to the sole author while editing
    if (this.props.authorEdit && this.props.values.length === 1) {
      document.getElementsByClassName('Select-value-icon')[0].style.display =
        'none'
    }
  }

  componentDidUpdate (prevProps, prevState) {
    // Hacky-css way to test if down to one author while editing, and remove the clickable 'x'
    // and also to re-add the clickable 'x' if editing to more than 1 author
    if (this.props.authorEdit) {
      const nodeList = [...document.getElementsByClassName('Select-value-icon')]
      if (
        prevState.selectedValues.length > 1 &&
        this.state.selectedValues.length === 1
      ) {
        nodeList.forEach(e => {
          e.style.display = 'none'
        })
      } else if (
        prevState.selectedValues.length === 1 &&
        this.state.selectedValues.length > 1
      ) {
        nodeList.forEach(e => {
          e.style.display = 'unset'
        })
      }
    }
  }

  render() {
    const { label, area, options, placeholder, headerClass } = this.props

    return (
      <div
        className={`area ${area}-wrapper ${this.state.active ? 'active' : ''}`}
        onMouseDown={this.onClickBound}
        onBlur={this.onBlurBound}
      >
        {label && <label className={`header ${headerClass}`}>{label}</label>}
        {this.props.tagEdit && (
          <Select.Creatable
            multi
            options={options}
            value={this.state.selectedValues}
            onChange={this.handleSelectChangeBound}
            placeholder={placeholder}
          />
        )}
        {!this.props.tagEdit && (
          <Select
            ref={this[area]}
            multi={!this.props.single}
            options={options}
            value={this.state.selectedValues}
            onChange={this.handleSelectChangeBound}
            placeholder={placeholder}
            clearable={!this.props.authorEdit}
            backspaceRemoves={this.props.authorEdit && this.state.selectedValues.length < 2 ? false : true}
            isLoading={this.props.loading}
          />
        )}
      </div>
    )
  }

  handleSelectChange (value) {
    this.setState({ selectedValues: value })
    if (this.props.filterAction) {
      if (this.props.single) {
        this.props.filterAction(value ? value.value : null)
      } else {
        this.props.dispatch(this.props.filterAction(
          value.map(function (v) {
            return v.value
          })
        ))
      }
      this.props.dispatch(this.props.fetchAction(1, true))
    } else {
      this.props.handleChange(value)
    }
  }

  onClick () {
    this.setState(() => {
      return {
        active: true
      }
    })
    if (!this.state.active) {
      setTimeout(() => {
        this[this.props.area].current.focus()
      }, 100)
    }
  }

  onBlur () {
    if (!this.state.selectedValues || this.state.selectedValues.length === 0) {
      this.setState(() => {
        return {
          active: false
        }
      })
    }
  }
}

SearchArea.propTypes = {
  dispatch: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  area: PropTypes.string.isRequired,
  filterAction: PropTypes.func,
  values: PropTypes.array,
  placeholder: PropTypes.string,
  authorEdit: PropTypes.bool,
  tagEdit: PropTypes.bool,
  loading: PropTypes.bool,
  headerClass: PropTypes.string,
  single: PropTypes.bool,
  handleChange: PropTypes.func,
  fetchAction: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/mini/SearchArea.js